'use client';

import Spinner from '@/components/ui/Spinner';
import { AuthProvider } from '@/contexts/AuthContext';
import '@ant-design/v5-patch-for-react-19';
import { App as AntdApp, ConfigProvider } from 'antd';
import { Inter } from 'next/font/google';
import { Suspense } from 'react';
import App from './App';
import './globals.css';

const inter = Inter({ subsets: ['latin'] });

// export const metadata = {
//   title: 'MyEye - Medical Dashboard',
//   description: 'HIPAA compliant medical dashboard system',
// };

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <html lang="en">
      <body className={inter.className}>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: '#1890ff',
              borderRadius: 6,
            },
          }}
        >
          <App>
            <AntdApp>
                <AuthProvider>
                  <Suspense fallback={<Spinner fullScreen />}>
                      {children}
                  </Suspense>
                </AuthProvider>
            </AntdApp>
          </App>
        </ConfigProvider>
      </body>
    </html>
  );
}
